import React from 'react';
import { motion } from 'framer-motion';
export function CTASection() {
  return <section id="contact" className="relative w-full py-24 md:py-32 overflow-hidden" data-id="element-35">
      <div className="absolute inset-0 bg-gold" data-id="element-36" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(0,0,0,0.1),transparent_60%)]" data-id="element-37" />

      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10 text-center" data-id="element-38">
        <motion.div initial={{
        opacity: 0,
        y: 25
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} data-id="element-39">
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-dark-900 mb-6" data-id="element-40">
            Start Your Adventure
          </h2>
          <p className="text-dark-900/70 text-base sm:text-lg max-w-2xl mx-auto mb-10 font-body leading-relaxed" data-id="element-41">
            Whether you're ready to buy, want a conversion quote, or simply have
            questions—we'd love to hear from you.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-42">
            <a href="#" className="w-full sm:w-auto px-8 py-4 bg-dark-900 text-white text-sm font-semibold tracking-widest uppercase rounded hover:bg-dark-800 transition-colors duration-300" data-id="element-43">
              View Current Stock
            </a>
            <a href="#" className="w-full sm:w-auto px-8 py-4 bg-white/90 text-dark-900 text-sm font-semibold tracking-widest uppercase rounded hover:bg-white transition-colors duration-300" data-id="element-44">
              Request a Quote
            </a>
            <a href="#" className="w-full sm:w-auto px-8 py-4 border-2 border-dark-900/30 text-dark-900 text-sm font-semibold tracking-widest uppercase rounded hover:border-dark-900/60 transition-colors duration-300" data-id="element-45">
              Contact Us
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}